import { render, staticRenderFns } from "./DiscordSection.vue?vue&type=template&id=f689a914&"
import script from "./DiscordSection.vue?vue&type=script&lang=js&"
export * from "./DiscordSection.vue?vue&type=script&lang=js&"
import style0 from "./DiscordSection.vue?vue&type=style&index=0&id=f689a914&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports